import { render, staticRenderFns } from "./QuizManagementForm.vue?vue&type=template&id=1bc767ad&"
import script from "./QuizManagementForm.vue?vue&type=script&lang=js&"
export * from "./QuizManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./QuizManagementForm.vue?vue&type=style&index=0&id=1bc767ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports